/*
 * Created by alex@hackerbay.com on 16.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import {translate} from "react-i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import Button from "@material-ui/core/es/Button/Button";
import {Col, Container, Row, Input} from "reactstrap";
import i18n from "i18next";
import genesys from "../../api/genesys";
import {SpacerRow} from "../../components/SpacerRow";
import BottomBarActive from "../../components/BottomBarActive";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import TextField from '@material-ui/core/TextField';
import {BrowserView,MobileView, isMobile} from "react-device-detect";
import SubPageTopBar from "../../components/SubPageTopBar";
import LoadingPage from "../LoadingPage";
import {STAGES} from "../Stage";
import {isDebugUser} from "../DebugMenu";
import vodafoneLogo from "../../media/icons/vf-logo.png";


/**
 * Debugging Switch to activate Console Logging for Stages
 * @type {boolean}
 */
const DEBUG = true;

class StageCallback extends React.Component {

    /**
     * constructor
     * @param props
     */
    constructor(props){
        super(props);
        this.state = {
            phoneNumber: "",
            submitting: false,
			hideShowButtonClass: 'showButtons',
			redButtonDisabled: true,
			//footerClass: 'test'
        }
    }

	/**
     * phone number input changed
     * @param event
     */
    phoneNumberInputChanged = (event) => {

		this.state.phoneNumber = event.target.value;
        this.setState({
            phoneNumber: event.target.value,
            error: "",
			// #205 CARE-811 replace all special characters in phoneNumber field during entry (+49 will be substituted with 0)
        });

		// Corrections: first number has to be "0", non numeric chars will be deleted
    	if( event.target.id == "phoneNumber" ) {
			//this.state.phoneNumber = this.state.phoneNumber.replace(/^[1-9]/,"").replace(/\+49/,"0").replace(/[^\d]/g, "");
		}
		//this.state.phoneNumber = this.state.phoneNumber.replace(/^[1-9]/,"").replace(/\+49/,"0").replace(/[^\d]/g, "");

		// enable button if phoneNumber is valid
		console.log('MS:');
		console.log(this.state.phoneNumber.length);
		console.log(this.state.phoneNumber);
		if( this.state.phoneNumber.length >= 10 ) {
			this.state.redButtonDisabled = false;
		} else {
			this.state.redButtonDisabled = true;
		}

    };
	
	/**
	 * Hide Button bar when display keyboard on mobile devices
	 * @param e
	 */
	hideButtonBar = (e) => {
		this.setState({ hideShowButtonClass: 'hideButtons'});
		this.setState(({ footerClass }) => ({ footerClass: 'hideButtons' }));
	}
	
	/**
	 * Show Button bar when hide keyboard on mobile devices
	 * @param e
	 */
	showButtonBar = (e) => {
		this.setState({ hideShowButtonClass: 'showButtons'});
		this.setState(({ footerClass }) => ({ footerClass: 'fixed-to-bottom' }));
	}
	
	/*updateContactInformationState = (event) => {
        const state = this.state;
        state.contactInformation[event.target.id] = event.target.value;
        this.setState(state,() => {this.updateSubmitButtonState()});
        //this.updateSubmitButtonState();
    };*/

    /**
     * Submit Callback Form
     * Calls genesys API and then this.props.callbackRequestCallback() (see MainPage.js);
     */
    requestCallback = () => {

        // FNX
            if( DEBUG ) console.log("FNX: requestCallback / Stage: "); console.log(this.stage);
            // this.setState({callbackRequestedSuccessfully: true});
            // this.setStage(STAGES.APPOINTMENT_DAY);

        if(!this.state.phoneNumber || this.state.phoneNumber.length < 10 ){
            if( DEBUG ) console.log(this.state.phoneNumber.length);
			return this.setState({error: i18n.t("error_missing_phone_number")})
        }

        this.setState({submitting: true});

        // for TESTUSERS: simulate genesys API call to submit callback request to VF systems
        // fnx 18.05.2020 auch für Testuser den ECHT-Call an die genesys API aktiviert
        // if( isDebugUser(this.props.urlIdent) === true ) {
        if( false && isDebugUser(this.props.urlIdent) === true ) {

            if( DEBUG ) console.log( "FNX: genesys success simulation - for testusers only - " + this.props.urlIdent);
            this.props.callbackRequestCallback();

        // for all other (regular) users -> execute error callback
        } else {

            // call genesys API to submit callback request to VF systems
            genesys(this.props.urlIdent, this.state.phoneNumber, this.props.ds360APIResult.KAS_CCB_KUNDEN_ID)
                .then(() => {
                    if( DEBUG ) console.log("FNX: genesys (on)fulfilled");
                    this.props.callbackRequestCallback();
                })
                .catch((e) => {
                    if( DEBUG ) console.log("FNX: genesys (on)rejected - " + this.props.urlIdent);
                    this.props.serverErrorCallback(e);
                });

        }
    };
	

    setFooterClass = () => {
		//this.setState(({ footerClass }) => ({ footerClass: '' }));
		this.setState({footerClass: ''});
	};


	/**
	 * render
	 * @returns {*}
	 */
	render() {
        if(this.state.submitting){
            return <LoadingPage/>
        }

        let callBackTitle = isMobile ? "callback_title" : "callback_title_desktop";
        let callBackBody1 = isMobile ? "callback_body_1" : "callback_body_1_desktop";
        let callBackBody2 = isMobile ? "callback_body_2" : "callback_body_2_desktop";
		let callBackBody3 = isMobile ? "callback_body_3" : "callback_body_3_desktop";
        let callBackButton = isMobile ? "request" : "request_desktop";

        // select text depending on TAM (RESULT_CODE)
        switch( parseInt( this.props.ds360APIResult.RESULT_CODE ) ) {

            case 6003:
                callBackTitle = "callback_title_6003";
                callBackBody1 = "callback_body_6003";
                callBackBody2 = "callback_body_2_6003";
				callBackBody3 = "";
                callBackButton = "callback_button_6003";
				// this.setFooterClass();
                break;

            case 6004:
            case 6005:
            case 6006:
            case 6007:
            case 6008:
            case 6009:
            case 6010:
            case 6011:
            case 6013:
                callBackTitle = "callback_title_60xx";
                callBackBody1 = "callback_body_1_60xx";
                callBackBody2 = "callback_body_2_60xx";
				callBackBody3 = "callback_body_3_60xx";
                callBackButton = "callback_button_60xx";
                break;
        }


        // TODO FooterLnk vorbereitet zum Einbau, wenn vom PO gewünscht
		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

        const callbackContent = <div>
            <Header
                textResource={callBackTitle}
            />
            <SpacerRow/>
            <TextBody
                textResource={callBackBody1}
				emoji_think = "&#129300;"
            />
			<br />
            <TextBody
                textResource={callBackBody2}
				emoji_up = "&#128077;"
            />
			<br />
			<TextBody
                textResource={callBackBody3}
				emoji_up = "&#128077;"
            />
			<br />
            <SpacerRow/>
            <TextField
                className={"width-100 myInputField desktopField"}
                type={"tel"}
				id={"phoneNumber"}
                label={i18n.t("contact_number")}
				inputProps={{
					maxLength: '30',
					minLength: '10'
				}}
			   placeholder=" "
			   onFocus={this.hideButtonBar}
			   onBlur={this.showButtonBar}
			   value={ this.state.phoneNumber ? this.state.phoneNumber.replace(/\+49/,"0").replace(/[^\d]/g, "") : "" }
			   onChange={this.phoneNumberInputChanged}
				validators={['matchRegexp:^(0049|0)[1-9][0-9]{6,}$']}
			/>
			<p>{this.state.error}</p>
        </div>


        const bottomBarContent = <BottomBar
			mainButtonOnClick={() => {
				this.state.apiAction = "callback";
				this.props.saveUserDataToCCApi( this.state );
				this.requestCallback();		// notwendig?
				this.props.commonSubmitCallback( this.state.selectedOption );
			}}
            mainButtonTextResource={callBackButton}
            className={this.state.hideShowButtonClass}
			disabled={this.state.redButtonDisabled}
        />;

        return <Container fluid={true} style={{backgroundColor:"white",height:"100%"}}>

            <MobileView>
                <Row className={"header"}>
					<Col xs={2} style={{marginLeft:"-15px"}}>
						<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
					</Col>
				</Row>
				<Row style={{paddingTop:"5vh"}}>
					<Col xs={{ size: 12 }}>
						{callbackContent}
					</Col>
				</Row>
                <Row className={'fixed-to-bottom'} style={{paddingBottom:"40px"}}>
					<Col xs={{ size: 12 }}>
						{bottomBarContent}
					</Col>
                </Row>
            </MobileView>

            <BrowserView>
				<Row className={"header desktop"}>
					<Col xs={12}>
						<div className={"container"}>
							<Row>
								<Col xs={2} style={{marginLeft:"-15px"}}>
									<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
								</Col>
							</Row>
						</div>
					</Col>
				</Row>
                <Container>
                    <Row style={{paddingTop:"20vh"}}>
        				<Col xs={{ size: 10, offset: 1 }}>
                            {callbackContent}
                            <SpacerRow/>
                        </Col>
                    </Row>
                    <Row>
        				<Col xl={{ size: 2, offset: 1 }} lg={{ size: 3, offset: 1 }} md={{ size: 4, offset: 1 }} sm={{ size: 6, offset: 1 }} xs={{ size: 12, offset: 0 }} >
                            {bottomBarContent}
                        </Col>
                    </Row>
                </Container>
            </BrowserView>

        </Container>
    }
}

export default translate("translations")(StageCallback);